"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    devToolSwitchStorageName: 'spaui-devtool-switch',
    devToolGlobalName: 'SPAUI_DEVTOOL_SWITCH'
};
